import UserCreator from "../../componants/users/UserCreator";

function AddUser(){
    return(
        <UserCreator>
            
        </UserCreator>
    )
}

export default AddUser;